export const QuestionList = [
  // 1페이지 목록
  {
    title: "현재 나는,",
    page: 1,
    step: 0,
    list: [
      { id: 1, text: "대학(원) 재학생 (휴학생 포함)", next: 2, },
      { id: 2, text: "실업자 / 구직자", next: 2, },
      { id: 3, text: "직장인", next: 2, },
      { id: 4, text: "자영업자, 사업자", next: 2, },
      { id: 5, text: "공무원, 사학연금수령자", next: "result", },
      { id: 6, text: "특수고용형태종사자, 프리랜서", next: 2, },
      { id: 7, text: "미성년자", next: 2, },
    ]
  },

  // 2페이지 목록
  {
    title: "재학중인 대학(원)은?",
    page: 2,
    step: 1,
    list: [
      { id: 11, text: "방송통신대학 및 사이버대학 등 원격대학", next: "checkList", },
      { id: 12, text: "2년제 대학", next: "checkList", },
      { id: 13, text: "3년제 대학", next: 3, },
      { id: 14, text: "4년제 대학", next: 3, },
    ]
  },
  {
    title: "현재 나의 나이는?",
    page: 2,
    step: 2,
    list: [
      { id: 21, text: "만 74세 이하", next: "checkList", },
      { id: 22, text: "만 75세 이상", next: "result", },
    ]
  },
  {
    title: "현재 직장 규모는?",
    page: 2,
    step: 3,
    list: [
      { id: 31, text: "대규모 기업", next: 3, },
      { id: 32, text: "중소/중견 기업", next: 3, },
    ]
  },
  {
    title: "현재 나의 매출액은?",
    page: 2,
    step: 4,
    list: [
      { id: 41, text: "매출액(년) 1억 5천만원 미만", next: "checkList", },
      { id: 42, text: "매출액(년) 1억 5천만원 이상", next: "result", },
      { id: 43, text: "사업자 낸 지 1년 미만", next: 3, },
    ]
  },
  {
    title: "현재 나의 매출액은?",
    page: 2,
    step: 6,
    list: [
      { id: 61, text: "매출액(년) 1억 5천만원 미만", next: "checkList", },
      { id: 62, text: "매출액(년) 1억 5천만원 이상", next: "result", },
    ]
  },
  {
    title: "현재 나의 학년은?",
    page: 2,
    step: 7,
    list: [
      { id: 71, text: "고등학교 2학년 이하", next: "result", },
      { id: 72, text: "고등학교 2학년 이상", next: "checkList", },
    ]
  },

  // 3페이지
  {
    title: "현재 학기는?",
    page: 3,
    step: 13,
    list: [
      { id: 131, text: "1학년 2학기 이전", next: "result", },
      { id: 132, text: "1학년 2학기 종료 (예정 포함)", next: "checkList", },
    ]
  },
  {
    title: "현재 학기는?",
    page: 3,
    step: 14,
    list: [
      { id: 141, text: "2학년 2학기 이전", next: "result", },
      { id: 142, text: "2학년 2학기 종료 (예정 포함)", next: "checkList", },
    ]
  },
  {
    title: "현재 나의 나이는?",
    page: 3,
    step: 31,
    list: [
      { id: 311, text: "만 45세 미만", next: "checkList", },
      { id: 312, text: "만 45세 이상", next: 3, },
    ]
  },
  {
    title: "현재 나의 나이는?",
    page: 3,
    step: 32,
    list: [
      { id: 321, text: "만 74세 이하", next: "checkList", },
      { id: 322, text: "만 75세 이상", next: "result", },
    ]
  },
  {
    title: "국민취업제도",
    page: 3,
    step: 43,
    list: [
      { id: 431, text: "국민취업제도 참여 중", next: "result", },
      { id: 432, text: "국민취업제도 미참여", next: "checkList", },
    ]
  },

  // 체크리스트 목록
  {
    title: "추가 사항 체크",
    page: "checkList",
    list: [
      {id: 1, text: "해당없음/모르겠음", next: "result"},
      {id: 2, text: "비정규직 근로자", next: "result"},
      {id: 3, text: "우선지원대상기업, 특별고용지원업종", next: "result"},
      {id: 4, text: "고용위기지역", next: "result"},
      {id: 5, text: "당해연도 기준 중위소득의 50% 이하", next: "result"},
      {id: 6, text: "당해연도 중위소득의 50% 초과 60% 이하", next: "result"},
    ]
  }
]